"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Stores = require("../store/ServiceManage");
var reactstrap_1 = require("reactstrap");
var ModalRegisterServiceComponent = /** @class */ (function (_super) {
    __extends(ModalRegisterServiceComponent, _super);
    function ModalRegisterServiceComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false,
            serName: "",
            createBy: "",
            isSave: false,
            classSpinner: "d-none"
        };
        _this.toggleModal = _this.toggleModal.bind(_this);
        _this.SaveClick = _this.SaveClick.bind(_this);
        _this.handleChangeSerName = _this.handleChangeSerName.bind(_this);
        _this.handleChangeCreateBy = _this.handleChangeCreateBy.bind(_this);
        return _this;
    }
    ModalRegisterServiceComponent.prototype.toggleModal = function () {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    ModalRegisterServiceComponent.prototype.handleChangeSerName = function (event) {
        this.setState({ serName: event.target.value });
    };
    ModalRegisterServiceComponent.prototype.handleChangeCreateBy = function (event) {
        this.setState({ createBy: event.target.value });
    };
    ModalRegisterServiceComponent.prototype.SaveClick = function () {
        this.setState({
            isSave: true,
            classSpinner: "d-inline-block"
        });
        this.props.requestFunction("", this.state.serName, this.state.createBy, "POST");
    };
    ModalRegisterServiceComponent.prototype.render = function () {
        if (this.props.isLoading && this.state.isSave) {
            this.props.BindData();
            this.toggleModal();
            this.setState({
                isSave: false
            });
        }
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Button, { color: "primary", onClick: this.toggleModal }, "Register Service"),
            React.createElement(reactstrap_1.Modal, { isOpen: this.state.isOpen },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggleModal }, "Register Service"),
                React.createElement(reactstrap_1.ModalBody, null,
                    React.createElement("label", { htmlFor: "txtServiceName" },
                        React.createElement("b", null, "Service Name")),
                    React.createElement("input", { type: "text", id: "txtServiceName", className: "form-control", value: this.state.serName, onChange: this.handleChangeSerName }),
                    React.createElement("label", { htmlFor: "txtCreateBy" },
                        React.createElement("b", null, "Create by Name")),
                    React.createElement("input", { type: "text", id: "txtCreateBy", className: "form-control", value: this.state.createBy, onChange: this.handleChangeCreateBy })),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement(reactstrap_1.Button, { color: "primary", onClick: this.SaveClick },
                        React.createElement(reactstrap_1.Spinner, { color: "primary", className: this.state.classSpinner, style: { width: '20px', height: '20px' } }),
                        ' ',
                        "Save"),
                    ' ',
                    React.createElement(reactstrap_1.Button, { color: "secondary", onClick: this.toggleModal }, "Cancel")))));
    };
    return ModalRegisterServiceComponent;
}(React.PureComponent));
exports.default = react_redux_1.connect(function (state) { return state.service; }, Stores.actionCreators)(ModalRegisterServiceComponent);
//# sourceMappingURL=ModalRegisterServiceComponent.js.map